import { appV2EventPrefix } from "@src/appV2/lib/analytics/events";

export const IN_HOME_USER_EVENTS = {
  VISIT_VIEWED: `${appV2EventPrefix} Home Health Open Visit Viewed`,
  VISIT_BOOKED: `${appV2EventPrefix} Home Health Visit Booked`,
  VISIT_LOGGED: `${appV2EventPrefix} Home Health Visit Logged`,
  VISIT_DROPPED: `${appV2EventPrefix} Home Health Visit Dropped`,
  VISIT_CONFIRMED: `${appV2EventPrefix} Home Health Visit Confirmed`,
  VISIT_PENDED: `${appV2EventPrefix} Home Health Visit Pended`,
  SCREENING_SURVEY_STARTED: `${appV2EventPrefix} Home Health Screening Survey Started`,
  SCREENING_SURVEY_STEP_COMPLETED: `${appV2EventPrefix} Home Health Screening Survey Step Completed`,
  SCREENING_SURVEY_SUBMITTED: `${appV2EventPrefix} Home Health Screening Survey Submitted`,
  SCREENING_SURVEY_PASSED: `${appV2EventPrefix} Home Health Screening Survey Passed`,
  SCREENING_SURVEY_WAITLISTED: `${appV2EventPrefix} Home Health Screening Survey Waitlisted`,
  SCREENING_SURVEY_WAITLIST_PAGE_VIEWED: `${appV2EventPrefix} Home Health Screening Survey Waitlist Page Viewed`,
  FILTERS_OPENED: `${appV2EventPrefix} Home Health Filters Opened`,
  FILTERS_APPLIED: `${appV2EventPrefix} Home Health Filters Applied`,
  FILTERS_CLEARED: `${appV2EventPrefix} Home Health Filters Cleared`,
  FILTERS_CLOSED: `${appV2EventPrefix} Home Health Filters Closed`,
};

export const IN_HOME_APP_EVENTS = {
  GET_BOOKED_CASES_FAILURE: `${appV2EventPrefix} Home Health Failed to load booked cases`,
  GET_SIGNATURES_FAILURE: `${appV2EventPrefix} Home Health Failed to load signatures`,
  GET_WORKER_STATISTICS_FAILURE: `${appV2EventPrefix} Home Health Failed to load worker statistics`,
  SCREENING_SURVEY_SUBMISSION_FAILED: `${appV2EventPrefix} Home Health Screening Survey Submission Failed`,
  SCREENING_SURVEY_STATUS_FETCH_FAILED: `${appV2EventPrefix} Home Health Screening Survey Status Fetch Failed`,
};
